// src/ui/swatch.ts
import type { Hsl } from '../types';

type SwatchOpts = {
  variant: 'target' | 'guess' | 'compact';
  tag?: string;
};

export function renderSwatch(hsl: Hsl, opts: SwatchOpts): string {
  const cls = `swatch ${opts.variant}`;
  const bg = `hsl(${hsl.h}, ${hsl.s}%, ${hsl.l}%)`;
  const tagHtml = opts.tag ? `<span class="tag">${escapeHtml(opts.tag)}</span>` : '';
  return `<div class="${cls}" style="background: ${bg};">${tagHtml}</div>`;
}

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
